<template>
  <tool-advance-form-filter-Content
    :contentInfo="contentInfo"
    :formModel="formModel"
    @onChangeFormModel="onChangeFormModel"
  ></tool-advance-form-filter-Content>
</template>
<script>
import { ToolAdvanceFormFilterContent } from "../../component/tool";
import { StartingYearWeek } from "../../helpers/constant";
import { CommonHelper } from "../../helpers";
import { InvestmentAdvanceFilterContent } from "../../mixin";
export default {
  props: {
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFormFilterContent },
  computed: {
    formModel() {
      return {
        type: "Form",
        groupFormat: [{ name: "", element: [0, 1], class: "" }],
        elements: [
          {
            type: "FormField",
            id: "371",
            label: "Maturity Date",
            dataType: "text",
            displayType: "monthPicker",
            htmlName: "maturityDate",
            value: this.baselineFilterObject.maturityDate,
            minYear: StartingYearWeek,
            yearTerm: 100,
          },
          {
            type: "FormField",
            id: "372",
            label: "Renew Automatically",
            dataType: "boolean",
            displayType: "switch",
            htmlName: "isRenewAuto",
            value: this.baselineFilterObject.isRenewAuto,
          },
        ],
        htmlName: "MaturityFilter",
        isResponsive: "true",
        size: {
          type: "Size",
          width: "0",
          height: "0",
        },
      };
    },
  },
  mixins: [InvestmentAdvanceFilterContent],
  data() {
    return {
      contentInfo: {
        heading: "Maturity Date",
        subHeading:
          "You can enter in maturity date details at different time periods.",
      },
    };
  },

  methods: {
    onChangeFormModel(formModel) {
      this.resetBaselineData(formModel);
    },
    resetBaselineData(formModel) {
      this.baselineFilterObject.isRenewAuto = CommonHelper.getFormProperties(
        "isRenewAuto",
        formModel
      );
      this.baselineFilterObject.maturityDate = CommonHelper.getFormProperties(
        "maturityDate",
        formModel
      );
      this.$emit("resetBaselineData", this.baselineFilterObject);
    },
  },
};
</script>
<style lang="scss" module></style>
